// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4d600c9b","453":"c91e24e0","455":"e4712c0d","977":"c8183746"}[chunkId] + ".chunk.js";
};